import React, { useContext, useEffect } from "react";
import AppRoutes from "../Routes/Routes";
import { AuthContext } from "../Context/AuthContext";
import NotificationToast from "../Components/Common/NotificationToast/NotificationToast";
// import { hasAffiliate } from "../Utils/utils";

const Layouts = ({ children }) => {
  const { userData, authUser } = useContext(AuthContext);

  // useEffect(() => {
  //   if (!hasAffiliate(userData)) {
  //     authUser();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  /*****/
  return (
    <React.Fragment>
      <AppRoutes />
      <NotificationToast
        variant="success"
        position={"bottom-end"}
        toastPosition={"bottom-end"}
        autoHide={true}
        delay={500000}
      />
    </React.Fragment>
  );
};

export default Layouts;
